import { useEffect, useMemo } from 'react'

/**
 * Creates a blob URL for a file and revokes it when the file changes or the
 * component unmounts. Calling URL.createObjectURL during render leaks a new URL
 * on every render and gives consumers a new src on each pass.
 */
export function useObjectUrl(file: File | null): string | undefined {
  const objectUrl = useMemo(
    () => (file ? URL.createObjectURL(file) : undefined),
    [file]
  )

  useEffect(() => {
    if (!objectUrl) return
    return () => URL.revokeObjectURL(objectUrl)
  }, [objectUrl])

  return objectUrl
}
